import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store.js';

// No auth views
import Login from './views/Login.vue';
import Register from './views/Register.vue';
import RegisterInvite from './views/RegisterInvite.vue';
import PasswordReset from './views/PasswordReset.vue';
import PasswordResetRequestSent from './views/PasswordResetRequestSent.vue';
import PasswordResetConfirm from './views/PasswordResetConfirm.vue';

// Auth views
import InquiryCreate from './views/InquiryCreate.vue';
import InquiryCopy from './views/InquiryCopy.vue';
import InquiryDraft from './views/InquiryDraft.vue';
import InquiryDetail from './views/InquiryDetail.vue';
import InquiryList from './views/InquiryList.vue';
import PayerOutageList from './views/PayerOutageList.vue';
import ProviderCreate from './views/ProviderCreate.vue';
import ProviderUpdate from './views/ProviderUpdate.vue';
import OrganizationDetail from './views/OrganizationDetail.vue';
import APIAccessKeys from './views/APIAccessKeys.vue';
import PlanList from './views/PlanList.vue';
import UserInvite from './views/UserInvite.vue';
import UserUpdate from './views/UserUpdate.vue';
import ProfileDetail from './views/ProfileDetail.vue';
import PasswordChange from './views/PasswordChange.vue';
import PatientVerificationList from './views/PatientVerificationList.vue';
import PatientVerificationCreate from './views/PatientVerificationCreate.vue';
import PatientVerificationDetail from './views/PatientVerificationDetail.vue';
import AdminPatientVerificationList from './views/admin/AdminPatientVerificationList.vue';
import AdminPatientVerificationDetail from './views/admin/AdminPatientVerificationDetail.vue';
import BlanketVOBList from './views/BlanketVOBList.vue';
import BlanketVOBDetails from './views/BlanketVOBDetails.vue';
import BlanketVOBAsInquiry from './views/BlanketVOBAsInquiry.vue';
import BlanketVOBCreate from './views/BlanketVOBCreate.vue';
import Reimbursement from './views/Reimbursement.vue';
import Reporting from './views/Reporting.vue';
import Alerting from './views/Alert.vue';
import AlertCreate  from './views/AlertCreate.vue';
import BatchInquiryCreate from './views/BatchInquiryCreate.vue';
import BatchInquiryReport from './views/BatchInquiryReport.vue';
import BatchInquiryList from './views/BatchInquiryList.vue';



// Admin views
import AdminOrganizationList from './views/admin/AdminOrganizationList.vue';
import AdminOrganizationDetail from './views/admin/AdminOrganizationDetail.vue';
import AdminInquiryList from './views/admin/AdminInquiryList.vue';
import AdminInquiryDetail from './views/admin/AdminInquiryDetail.vue';
import AdminInviteList from './views/admin/AdminInviteList.vue';
import AdminPayerDetail from './views/admin/AdminPayerDetail.vue';
import AdminPayerCreate from './views/admin/AdminPayerCreate.vue';
import AdminPayerList from './views/admin/AdminPayerList.vue';
import AdminPayerMerge from './views/admin/AdminPayerMerge.vue';
import AdminPayerUpload from './views/admin/AdminPayerUpload.vue';
import AdminPayersPrefixesUpload from './views/admin/AdminPayersPrefixesUpload.vue';
import AdminPayerUpdate from './views/admin/AdminPayerUpdate.vue';
import AdminProviderList from './views/admin/AdminProviderList.vue';
import AdminReimbursementList from './views/admin/AdminReimbursementList.vue';
import AdminReimbursementUpload from './views/admin/AdminReimbursementUpload.vue';
import AdminReimbursementPayerList from './views/admin/AdminReimbursementPayerList.vue';
import AdminReimbursementEmployerList from './views/admin/AdminReimbursementEmployerList.vue';
import AdminReimbursementGroupList from './views/admin/AdminReimbursementGroupList.vue';
import AdminReimbursementPrefixList from './views/admin/AdminReimbursementPrefixList.vue';
import AdminReimbursementAggregationList from './views/admin/AdminReimbursementAggregationList.vue';
import AdminUserList from './views/admin/AdminUserList.vue';
import AdminUserInvite from './views/admin/AdminUserInvite.vue';
import AdminUserUpdate from './views/admin/AdminUserUpdate.vue';
import AdminRegisterPopulate from './views/admin/AdminRegisterPopulate.vue';
import AdminBlanketVOBList from './views/admin/AdminBlanketVOBList.vue';
import AdminBlanketVOBDetails from './views/admin/AdminBlanketVOBDetails.vue';
import AdminBatchInquiryList from './views/admin/AdminBatchInquiryList.vue';
import AdminBatchInquiryReport from './views/admin/AdminBatchInquiryReport.vue';
import AdminReporting from './views/admin/AdminReporting.vue';
import InquiryAsBlanketVOB from './views/InquiryAsBlanketVOB.vue';
import AdminAlertsPayerList from './views/admin/AdminAlertPayerList.vue';
import AdminAlertGroupNumberList from './views/admin/AdminAlertGroupNumberList.vue';
import AdminAlertGroupNameList from './views/admin/AdminAlertGroupNameList.vue';
import AdminAlertPlanNumberList from './views/admin/AdminAlertPlanNumberList.vue';
import AdminAlertPlanNameList from './views/admin/AdminAlertPlanNameList.vue';
import AdminAlertInsuranceTypeList from './views/admin/AdminAlertInsuranceTypeList.vue';
import AdminAlertPrefixList from './views/admin/AdminAlertPrefixList.vue';
import AdminProviderUpdate from './views/admin/AdminProviderUpdate.vue';


// Misc views
import NotFound from './views/NotFound.vue';
import Unsubscribed from './views/Unsubscribed.vue';
import TermsAndConditions from './views/TermsAndConditions.vue';
import TermsAndConditionsAccept from './views/TermsAndConditionsAccept.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: { name: 'InquiryList' },
    meta: { requiresAuth: true },
  },
  {
    path: '/inquiries/new',
    name: 'InquiryCreate',
    component: InquiryCreate,
    meta: { requiresAuth: true },
  },
  {
    path: '/inquiries',
    name: 'InquiryList',
    component: InquiryList,
    meta: { requiresAuth: true },
  },
  {
    path: '/batch-inquiries',
    name: 'BatchInquiryList',
    component: BatchInquiryList,
    meta: { requiresAuth: true, requiresBatchInquiry: true },
  },
  {
    path: '/batch-inquiries/new',
    name: 'BatchInquiryCreate',
    component: BatchInquiryCreate,
    meta: { requiresAuth: true, requiresBatchInquiry: true },
  },
  {
    path: '/batch-inquiries/:id(\\d+)',
    name: 'BatchInquiryReport',
    component: BatchInquiryReport,
    meta: { requiresAuth: true, requiresBatchInquiry: true },
  },
  {
    path: '/payer-outage',
    name: 'PayerOutageList',
    component: PayerOutageList,
    meta: { requiresAuth: true },
  },
  {
    path: '/inquiries/:id([A-Z0-9]{26})',
    name: 'InquiryDetail',
    component: InquiryDetail,
    meta: { requiresAuth: true },
  },
  {
    path: '/inquiries/:id([A-Z0-9]{26})/copy',
    name: 'InquiryCopy',
    component: InquiryCopy,
    meta: { requiresAuth: true },
  },
  {
    path: '/inquiries/:id([A-Z0-9]{26})/draft',
    name: 'InquiryDraft',
    component: InquiryDraft,
    meta: { requiresAuth: true },
  },
  {
    path: '/patient-verifications',
    name: 'PatientVerificationList',
    component: PatientVerificationList,
    meta: { requiresAuth: true },
  },
  {
    path: '/patient-verifications/new',
    name: 'PatientVerificationCreate',
    component: PatientVerificationCreate,
    meta: { requiresAuth: true },
  },
  {
    path: '/patient-verifications/:id',
    name: 'PatientVerificationDetail',
    component: PatientVerificationDetail,
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/patient-verifications',
    name: 'AdminPatientVerificationList',
    component: AdminPatientVerificationList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/patient-verifications/:id',
    name: 'AdminPatientVerificationDetail',
    component: AdminPatientVerificationDetail,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/blanket-vob-search',
    name: 'BlanketVOBList',
    component: BlanketVOBList,
    meta: { requiresAuth: true },
  },
  {
    path: '/blanket-vob-search/new',
    name: 'BlanketVOBCreate',
    component: BlanketVOBCreate,
    meta: { requiresAuth: true },
  },
  {
    path: '/blanket-vob-search/details/:id/:payerResponseId?',
    name: 'BlanketVOBDetails',
    component: BlanketVOBDetails,
    meta: { requiresAuth: true },
  },
  {
    path: '/blanket-vob-search/inquiry/:id',
    name: 'BlanketVOBAsInquiry',
    component: BlanketVOBAsInquiry,
    meta: { requiresAuth: true },
  },
  {
    path: '/reimbursement',
    name: 'Reimbursement',
    component: Reimbursement,
    meta: { requiresAuth: true },
  },
  {
    path: '/inquiries/blanket-vob/:id',
    name: 'InquiryAsBlanketVOB',
    component: InquiryAsBlanketVOB,
    meta: { requiresAuth: true },
  },
  //
  // Organization
  //

  {
    path: '/organization/settings/plan',
    name: 'PlanList',
    component: PlanList,
    meta: { requiresAuth: true, requiresManager: true },
  },
  {
    path: '/organization/settings',
    name: 'OrganizationDetail',
    component: OrganizationDetail,
    meta: { requiresAuth: true, requiresManager: true },
  },
  {
    path: '/organization/settings/api-access',
    name: 'APIAccessKeys',
    component: APIAccessKeys,
    meta: { requiresAuth: true, requiresManager: true },
  },
  {
    path: '/reporting',
    name: 'Reporting',
    component: Reporting,
    meta: { requiresAuth: true, requiresManager: true },
  },
    {
    path: '/alerting',
    name: 'Alerting',
    component: Alerting,
    meta: { requiresAuth: true, requiresManager: true },
  },
  {
    path: '/alerting/new',
    name: 'AlertCreate',
    component: AlertCreate,
    meta: { requiresAuth: true, requiresManager: true },
  },
  {
    path: '/organization/users/:id/update',
    name: 'UserUpdate',
    component: UserUpdate,
    meta: { requiresAuth: true, requiresManager: true },
  },
  {
    path: '/organization/users/new',
    name: 'UserInvite',
    component: UserInvite,
    meta: { requiresAuth: true, requiresManager: true },
  },
  {
    path: '/organization/providers/new',
    name: 'ProviderCreate',
    component: ProviderCreate,
    meta: { requiresAuth: true, requiresManager: true },
  },
  {
    path: '/organization/providers/:id/update',
    name: 'ProviderUpdate',
    component: ProviderUpdate,
    meta: { requiresAuth: true, requiresManager: true },
  },

  //
  // Admin
  //

  {
    path: '/admin',
    name: 'AdminIndex',
    redirect: { name: 'AdminOrganizationList' },
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/inquiries',
    name: 'AdminInquiryList',
    component: AdminInquiryList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/inquiries/:id',
    name: 'AdminInquiryDetail',
    component: AdminInquiryDetail,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/users',
    name: 'AdminUserList',
    component: AdminUserList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/invites',
    name: 'AdminInviteList',
    component: AdminInviteList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/payers',
    name: 'AdminPayerList',
    component: AdminPayerList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/payers/merge',
    name: 'AdminPayerMerge',
    component: AdminPayerMerge,
    meta: { requiresAuth: true, requiresAdmin: true },
  },

  {
    path: '/admin/payers/:id',
    name: 'AdminPayerDetail',
    component: AdminPayerDetail,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/payers/:id/update',
    name: 'AdminPayerUpdate',
    component: AdminPayerUpdate,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/payers/upload',
    name: 'AdminPayerUpload',
    component: AdminPayerUpload,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/payers/new',
    name: 'AdminPayerCreate',
    component: AdminPayerCreate,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/payers/prefixes/upload',
    name: 'AdminPayersPrefixesUpload',
    component: AdminPayersPrefixesUpload,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/providers',
    name: 'AdminProviderList',
    component: AdminProviderList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
   {
    path: '/admin/providers/:id/update',
    name: 'AdminProviderUpdate',
    component: AdminProviderUpdate,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/organizations',
    name: 'AdminOrganizationList',
    component: AdminOrganizationList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/organizations/:id',
    name: 'AdminOrganizationDetail',
    component: AdminOrganizationDetail,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/organizations/:id/invite',
    name: 'AdminUserInvite',
    component: AdminUserInvite,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/register/populate',
    name: 'RegistrationPopulate',
    component: AdminRegisterPopulate,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/blanket-vob-search',
    name: 'AdminBlanketVOBList',
    component: AdminBlanketVOBList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/blanket-vob-search/:id/:payerResponseId?',
    name: 'AdminBlanketVOBDetails',
    component: AdminBlanketVOBDetails,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/batch-inquiries',
    name: 'AdminBatchInquiryList',
    component: AdminBatchInquiryList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/batch-inquiries/:id',
    name: 'AdminBatchInquiryReport',
    component: AdminBatchInquiryReport,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/reimbursements',
    name: 'AdminReimbursementList',
    component: AdminReimbursementList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/reimbursements/upload',
    name: 'AdminReimbursementUpload',
    component: AdminReimbursementUpload,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/reimbursements/payers',
    name: 'AdminReimbursementPayerList',
    component: AdminReimbursementPayerList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/reimbursements/employers',
    name: 'AdminReimbursementEmployerList',
    component: AdminReimbursementEmployerList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/reimbursements/groups',
    name: 'AdminReimbursementGroupList',
    component: AdminReimbursementGroupList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/reimbursements/prefixes',
    name: 'AdminReimbursementPrefixList',
    component: AdminReimbursementPrefixList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/reimbursements/aggregations',
    name: 'AdminReimbursementAggregationList',
    component: AdminReimbursementAggregationList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/users/:id/update',
    name: 'AdminUserUpdate',
    component: AdminUserUpdate,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/notifications',
    name: 'AdminNotificationManager',
    component: () => import('./views/admin/AdminNotificationManager.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/mobile-app-version-policy',
    name: 'AdminMobileAppVersionPolicy',
    component: () => import('./views/admin/AdminMobileAppVersionPolicy.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/reporting',
    name: 'AdminReporting',
    component: AdminReporting,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/alerts/payers',
    name: 'AdminAlertPayerList',
    component: AdminAlertsPayerList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/alerts/group-numbers',
    name: 'AdminAlertGroupNumberList',
    component: AdminAlertGroupNumberList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/alerts/group-names',
    name: 'AdminAlertGroupNameList',
    component: AdminAlertGroupNameList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/alerts/plan-numbers',
    name: 'AdminAlertPlanNumberList',
    component: AdminAlertPlanNumberList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/alerts/plan-names',
    name: 'AdminAlertPlanNameList',
    component: AdminAlertPlanNameList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
   {
    path: '/admin/alerts/insurance-types',
    name: 'AdminAlertInsuranceTypeList',
    component: AdminAlertInsuranceTypeList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
    {
    path: '/admin/alerts/prefixes',
    name: 'AdminAlertPrefixList',
    component: AdminAlertPrefixList,
    meta: { requiresAuth: true, requiresAdmin: true },
  },

  //
  // Organization
  //

  {
    path: '/settings',
    name: 'ProfileDetail',
    component: ProfileDetail,
    meta: { requiresAuth: true },
  },

  {
    path: '/settings/password-change',
    name: 'PasswordChange',
    component: PasswordChange,
    meta: { requiresAuth: true },
  },

  //
  // Auth
  //

  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
  },
  {
    path: '/register/:id([A-Z0-9]{26})',
    name: 'RegisterInvite',
    component: RegisterInvite,
  },
  {
    path: '/password-reset',
    name: 'PasswordReset',
    component: PasswordReset,
  },
    {
    path: '/password-reset-request-sent',
    name: 'PasswordResetRequestSent',
    component: PasswordResetRequestSent,
  },
  {
    // The url is also in password_reset_email.html.
    path: '/password-reset/:uid/:token',
    name: 'PasswordResetConfirm',
    component: PasswordResetConfirm,
  },

  //
  // Global
  //
  {
    path: '/terms',
    name: 'TermsAndConditions',
    component: TermsAndConditions,
  },
  {
    path: '/terms/accept',
    name: 'TermsAndConditionsAccept',
    component: TermsAndConditionsAccept,
    meta: { requiresAuth: true },
  },

  { path: '/404', name: 'NotFound', component: NotFound },
  { path: '/unsubscribed', name: 'Unsubscribed', component: Unsubscribed },
  { path: '/:pathMatch(.*)*', redirect: { name: 'NotFound' } },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// Add global navigation guard to handle navigation errors
const originalPush = router.push;
router.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    // Ignore common navigation errors that are not actual errors
    if (
      err.name === 'NavigationDuplicated' ||
      err.name === 'NavigationCancelled' ||
      err.message?.includes('Navigation cancelled') ||
      err.message?.includes('Navigation aborted') ||
      err.message?.includes('Redirected when going from')
    ) {
      // These are not actual errors, just navigation state changes
      return Promise.resolve();
    }
    throw err;
  });
};

// This route is needed to select a subscription plan. We can redirect
// here if the user has no other plan.
const subscriptionRoute = 'PlanList';

const tosAcceptRoute = 'TermsAndConditionsAccept';

router.beforeEach(async (to, from, next) => {
  try {
    // Refresh on initial load and periodically to slide the session window.
    // The store reuses recent successful refreshes and deduplicates concurrent ones.
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      try {
        await store.dispatch('refresh', { force: Boolean(to.query.session_id) });

        // Check Terms of service.
        if (
          !store.getters.hasCurrentTOS &&
          to.name !== tosAcceptRoute &&
          store.getters.hasActiveSubscription
        ) {
          // The active subscription check is required so we don't get infinite loop with subscription check.
          return next({ name: tosAcceptRoute, query: { next: to.path } });
        }

        // Admin just shows notfound instead of redirecting to login
        if (to.matched.some((record) => record.meta.requiresAdmin)) {
          if (!store.getters.isAdmin) {
            return next({ name: 'NotFound' });
          }
        }

        // Admin just shows notfound instead of redirecting to login
        if (to.matched.some((record) => record.meta.requiresManager)) {
          if (!store.getters.isManager) {
            return next({ name: 'NotFound' });
          }
        }

        // Batch reports require the per-user "Can Run Batch Reports" permission.
        if (to.matched.some((record) => record.meta.requiresBatchInquiry)) {
          if (!store.getters.permBatchInquiry) {
            return next({ name: 'NotFound' });
          }
        }

        // Saved verifier results remain readable without an active subscription.
        const isPatientVerificationHistory = [
          'PatientVerificationList',
          'PatientVerificationDetail',
          'AdminPatientVerificationList',
          'AdminPatientVerificationDetail',
        ].includes(to.name);

        // Subscription
        // Do we need to even check public routes? What if they are browsing?
        // Allow users with active OR past due subscriptions to access the app
        if (
          store.getters.isLoggedIn &&
          store.getters.isManager &&
          !store.getters.hasActiveSubscription &&
          !store.getters.hasPastDueSubscription &&
          !isPatientVerificationHistory
        ) {
          if (to.name !== subscriptionRoute) {
            // Pass session_id query param when redirecting (for Stripe checkout success)
            return next({
              name: 'PlanList',
              query: to.query.session_id ? { session_id: to.query.session_id } : {},
            });
          }
        }

        if (
          store.getters.isLoggedIn &&
          !store.getters.isManager &&
          !store.getters.hasActiveSubscription &&
          !store.getters.hasPastDueSubscription &&
          !isPatientVerificationHistory
        ) {
          if (to.name !== subscriptionRoute) {
            return next({ name: 'Unsubscribed' });
          }
        }

        // If we get here, authentication succeeded and all checks passed
        return next();
      } catch (error) {
        // Authentication failed - redirect to login
        // Pass original url to login url as a param so we can redirect after login.
        // Don't redirect to login if already going to login (prevents loop)
        if (to.name === 'Login') {
          return next();
        }
        return next({ name: 'Login', query: { next: to.path } });
      }
    }

    next();
  } catch (error) {
    // Catch any unexpected errors in the navigation guard
    // This prevents navigation guard errors from being thrown
    console.warn('Navigation guard error caught:', error.message);

    // If there's an error, just allow the navigation to proceed
    // This is a fallback to prevent the app from breaking
    next();
  }
});

export default router;
